
import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment/forecast`;

export const forecastService = {

    url_lu_forecastperiods: `${GATEWAY_URL}/lu_forecastperiods`,
    url_lu_forecastgroups: `${GATEWAY_URL}/lu_forecastgroups`,
    url_lu_salechannels: `${GATEWAY_URL}/lu_salechannels`,
    url_lu_location: `${GATEWAY_URL}/lu_locations`,
    url_lu_productcategories: `${GATEWAY_URL}/lu_productcategories`,

    // getForecastList: async function (siteCode: string, productCode: string, forecastGroup: string, productSegment: string) {
    //     return axios.get(`${GATEWAY_URL}/forecast_list`, {
    //         params: {
    //             siteCode: siteCode,
    //             productCode: productCode,
    //             forecastGroup: forecastGroup,
    //             productSegment: productSegment
    //         }
    //     })
    //         .then((response) => {
    //             return response.data;
    //         });
    // },



    getForecastGroupLookups: async function () {
        return axios.get(`${GATEWAY_URL}/forecast_group_lookup`, {
        })
            .then((response) => {
                return response.data;
            });
    },

    getProductSegmentGroupLookups: async function () {
        return axios.get(`${GATEWAY_URL}/product_segment_lookup`, {
        })
            .then((response) => {
                return response.data;
            });
    },

    getForecastLocationLookups: async function () {
        return axios.get(`${GATEWAY_URL}/forecast_location_lookup`, {
        })
            .then((response) => {
                return response.data;
            });
    },

    getForecastProductLookups: async function (SiteCode: any) {
        return axios.get(`${GATEWAY_URL}/forecast_product_lookup`, {
            params: {
                SiteCode: SiteCode,
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    // getForecastDetailList: async function (siteCode: string, productCode: string) {
    //     return axios.get(`${GATEWAY_URL}/forecast_detail_list`, {
    //         params: {
    //             SiteCode: siteCode,
    //             ProductCode: productCode, 
    //         }
    //     })
    //         .then((response) => {
    //             return response.data;
    //         });
    // },

    getForecastList: async function (params: any) {
        return axios.get(`${GATEWAY_URL}/forecast_list`, {
            params: params
        })
            .then((response) => {
                return response.data;
            });
    },


    getForecastDetailList: async function (headerId: number, productCode: string) {
        return axios.get(`${GATEWAY_URL}/tr_forecast_accuracy_data`, {
            params: {
                HeaderId: headerId,
                ProductCode: productCode,
            }
        })
            .then((response) => {
                return response.data;
            });
    },



}
